import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const OrderDetails = () => {
  const {t}= useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const order = state?.order;
   const { clientData, isAuthenticated } = useAuth();
    useEffect(() => {
      if (!clientData || !isAuthenticated){ navigate("/login"); return;}     
    }, []);
    
    if (!order) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4">
          <p className="text-red-500">{t('Ordernotfound')}</p>
          <button 
            onClick={() => navigate('/orders')}
            className="px-4 py-2 bg-green-700 text-white rounded hover:bg-green-600 transition-colors"
          >
            {('ViewOrders')}
          </button>
        </div>
      );
    }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/orders')}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </button>
          <h1 className="text-2xl font-bold">{t('OrderID')} #{order.order_id}</h1>
        </div>
        <button
          onClick={() => window.open(`${config.hostUrl}/paymentsuccess?OrderId=${order.order_id}&isJustView=true&payment_id=${order.payments.payment_id}`, '_blank')}
          className="flex items-center px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z" clipRule="evenodd" />
          </svg>
          {t('PrintInvoice')}
        </button>
      </div>

      <div className="space-y-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold mb-4">{t('OrderSummary')}</h2>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-500">{t('Date')}</p>
                <p className="font-medium">
                  {new Date(order.order_date).toLocaleDateString()}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">{t('Status')}</p>
                <span className="inline-block px-3 py-1 rounded-full text-sm bg-gray-100">
                  {order.status}
                </span>
              </div>
              <div>
                <p className="text-sm text-gray-500">{t('address')}</p>
                <p className="font-medium">
                  {JSON.parse(order.shipping_address).street || "Not provided"}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">{t('PaymentMethod')}</p>
                <p className="font-medium">
                  {order.payments[0]?.payment_method || "Not provided"}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">{t('Tracking')}</p>
                <p className="font-medium">
         {order.tracking_number ? (
            <a href={`https://www.aramex.com/ae/en/track/results?source=aramex&ShipmentNumber=${order.tracking_number}`} target="_blank" rel="noopener noreferrer">
              <img src="https://dotcomaramexprod.blob.core.windows.net/default/docs/default-source/logo/aramex-logo-english.webp" alt="Aramex" className="inline-block h-4 mr-1" />
              {order.tracking_number}
            </a>
            ) : (
            "Not provided"
            )}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">{t('PaymentStatus')}</p>
                <p className="font-medium">
                  {order.payments[0]?.payment_status|| "Not provided"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold mb-4">{t('Products')}</h2>
          <div className="space-y-4">
            {order.OrderItems.map((item) => (
              <div 
                key={item?.order_item_id}
                className="flex justify-between items-center py-2 border-b last:border-b-0"
              >
                <div>
                  <p className="font-medium">{item?.Product?.name}</p>
                  <p className="text-sm text-gray-500">
                    {t('Quantity')}: {item?.quantity}
                  </p>
                </div>
                <p className="font-medium">
                  {order.Branch.currency} {item?.unit_price.toFixed(2)}
                </p>
              </div>
            ))}
            
            <div className="flex justify-between items-center pt-4">
              <p className="font-bold">{t('Total')}</p>
              <p className="font-bold">
                {order.Branch.currency} {order.total_amount.toFixed(2)}
              </p>
            </div>
          </div>
        </div>

        {order.payments[0]?.payment_status === "Failed" && (
          <button 
            onClick={() => navigate(`/orders/${order.order_id}/pay`)}
            className="w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
          >
            {t('RetryPayment')}
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderDetails;